import React, { useContext } from 'react';
import AuthWrapper from '../Auth/AuthWrapper/AuthWrapper';
import styles from './styles.module.css';
import { Row, Col } from 'react-flexbox-grid';
import hotel1 from './hotel1.jpg';
import Menu from './Menu'
import * as Icon from '../../components/Icons';
import { LanguageContext } from '../../context/Languages/LanguageProvider';

const Bookings = () => {
    const { i18n } = useContext(LanguageContext);

    return (
        <AuthWrapper>
            <div className={styles.profile}>
                <Menu />
                <Row>
                    <Col lg={10} xs={12}>
                        <div className={styles.header}>
                            <h3>{i18n.myBookings}</h3>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={10} xs={12}>
                        <div className={styles.rightSide}>
                            <div className={styles.bookings}>
                                <div className={styles.bookingData}>
                                    <Row>
                                        <Col lg={3} xs={5}>
                                            <div className={styles.hotelImage}>
                                                <img src={hotel1} alt={'hotelImage'} />
                                            </div>
                                        </Col>
                                        <Col lg={6} xs={7}>
                                            <div className={styles.bookingDetail}>
                                                <h3>Kandima Maldives</h3>
                                                <Row>
                                                    <Col lg={4}>
                                                        <h5>{i18n.checkIn}</h5>
                                                        <p>Fri 01 SEP 2020</p>
                                                        <small>{i18n.from} 14:00</small>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <h5>{i18n.checkOut}</h5>
                                                        <p>Fri 04 SEP 2020</p>
                                                        <small>{i18n.from} 14:00</small>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                        <Col lg={3}>
                                            <div className={styles.prices}>
                                                <p>{i18n.from}</p>
                                                <p className={styles.price}>$270</p>
                                                <p>{i18n.night}</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className={styles.bookingData}>
                                    <Row>
                                        <Col lg={3} xs={5}>
                                            <div className={styles.hotelImage}>
                                                <img src={hotel1} width={'150px'} alt={'hotelImage'} />
                                            </div>
                                        </Col>
                                        <Col lg={6} xs={7}>
                                            <div className={styles.bookingDetail}>
                                                <h3>Kandima Maldives</h3>
                                                <Row>
                                                    <Col lg={4}>
                                                        <h5>{i18n.checkIn}</h5>
                                                        <p>Fri 01 SEP 2020</p>
                                                        <small>{i18n.from} 14:00</small>
                                                    </Col>
                                                    <Col lg={4}>
                                                        <h5>{i18n.checkOut}</h5>
                                                        <p>Fri 01 SEP 2020</p>
                                                        <small>{i18n.to} 14:00</small>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                        <Col lg={3}>
                                            <div className={styles.prices}>
                                                <p>From</p>
                                                <p className={styles.price}>$270</p>
                                                <p>Night</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className={styles.counts}>
                                <div lg={3} className={styles.count}>
                                    <div className={styles.icon}>
                                        <Icon.Rooms />
                                    </div>
                                    <div className={styles.countName}>
                                        <p>15</p>
                                        <p>{i18n.rooms}</p>
                                    </div>
                                </div>
                                <div lg={3} className={styles.count}>
                                    <div className={styles.icon}>
                                        <Icon.Calendars />
                                    </div>
                                    <div className={styles.countName}>
                                        <p>43</p>
                                        <p>{i18n.days}</p>
                                    </div>
                                </div>
                                <div lg={3} className={styles.count}>
                                    <div className={styles.icon}>
                                        <Icon.Photos />
                                    </div>
                                    <div className={styles.countName}>
                                        <p>112</p>
                                        <p>{i18n.photos}</p>
                                    </div>
                                </div>
                                <div lg={3} className={styles.count}>
                                    <div className={styles.icon}>
                                        <Icon.Comments />
                                    </div>
                                    <div className={styles.countName}>
                                        <p>32</p>
                                        <p>{i18n.comments}</p>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.privacy}>
                                <p>
                                    {i18n.privacyText1}
                                </p>
                                <p>
                                    {i18n.privacyText2}

                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </AuthWrapper>
    );
};

export default Bookings;
